import { Injectable } from "@angular/core";
declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class JqueryUtils {
    constructor() {
    }
    openModal(modalID: string) {
        $('#' + modalID).modal('show');
    }
    closeModal(modalID: string) {
        $('#' + modalID).modal('hide');
    }
    setMaxDate(id: any, date: any) {
        $('#' + id).attr('max', date);
    }
    // initializeMenu() {
    //     $('.sidebar-menu li a').click(function (e: any) {
    //         $('.sidebar-menu li.active').removeClass('active');
    //         let obj: any = this
    //         $(obj).parent().addClass('active');
    //     });
    // }
    highlight() {
        $('.sidebar-menu li.active').removeClass('active');
        $("#ordersMenu").parent().addClass('active');
    }
    setActiveTab(id: any) {
        let ele = document.getElementById(id)
        if (ele != null) {
            ele.click();
        }
    }
}